import React from 'react';

import { CollapsibleCommentContent as SharedCollapsibleCommentContent } from '@atlassian/cc-comment-agent-ui/collapsible-comment-content';

import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const COMMENTS_SHOW_PARAMS_CONFIG = 'platform_editor_comments_show_params';
const DEFAULT_COMMENT_SHOW_PARAMS = { collapseThreshold: 360, collapsedHeight: 200 };

const getCommentShowParams = (): { collapseThreshold: number; collapsedHeight: number } => {
	try {
		const params = JSON.parse(
			StatsigConfigurations.getString(
				COMMENTS_SHOW_PARAMS_CONFIG,
				JSON.stringify(DEFAULT_COMMENT_SHOW_PARAMS),
			),
		) as { collapseThreshold?: unknown; collapsedHeight?: unknown };
		return {
			collapseThreshold:
				typeof params.collapseThreshold === 'number'
					? params.collapseThreshold
					: DEFAULT_COMMENT_SHOW_PARAMS.collapseThreshold,
			collapsedHeight:
				typeof params.collapsedHeight === 'number'
					? params.collapsedHeight
					: DEFAULT_COMMENT_SHOW_PARAMS.collapsedHeight,
		};
	} catch {
		return DEFAULT_COMMENT_SHOW_PARAMS;
	}
};

export const CollapsibleCommentContent = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<SharedCollapsibleCommentContent {...getCommentShowParams()}>
		{children}
	</SharedCollapsibleCommentContent>
);
